import { render } from "./ExportExcel.vue?vue&type=template&id=b72cf9c6"
import script from "./ExportExcel.vue?vue&type=script&lang=js"
export * from "./ExportExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__